import Modal from '../../Common/Modal';
import Button from '../../Common/Button';
import { Booking } from '@deliveries-app/models';
import { useRouter } from 'next/router';
import moment from 'moment-timezone';
import { darkenColor } from '../../../utils/helpers';

interface DetailBookingProps {
  booking: Booking;
  open: boolean;
  onClose: () => void;
  onCompleted: () => void;
  onHold: () => void;
  children?: React.ReactNode;
  onCharge: () => void;
  onDelete: () => void;
}

const DetailModal = ({
  booking,
  open,
  onClose,
  children,
  onCharge,
  onCompleted,
  onDelete,
  onHold,
}: DetailBookingProps) => {
  const router = useRouter();

  const onDuplicate = () => {
    router.push(`/bookings/${booking.id}?duplicate=true`);
  };

  const onEdit = () => {
    router.push(`/bookings/${booking.id}`);
  };

  const formattedCreatedAt = moment(booking.created_at)
    .tz(booking.branch.timezone)
    .format('Do MMMM YYYY h:mma');

  const findTime = () => {
    const [lat, lng] = booking.delivery_location.latlng.coordinates;
    router.push(
      `/?lat=${lng}&lng=${lat}&reschedule=false&bookingId=${booking.id}&unhold=true`
    );
  };

  return (
    <Modal type="large" open={open} closeModal={onClose}>
      <div className="flex flex-row justify-between">
        <div className="flex w-full flex-row items-center justify-between">
          <div>
            <h3 className="text-2xl font-medium">
              Booking - #{booking.id}{' '}
              <span className="text-red-400">
                {booking.on_hold ? 'Hold' : ''}
              </span>
            </h3>
          </div>
          <div>
            <Button
              type="button"
              className="text-white"
              style={{
                backgroundColor: booking.branch.branch_colour,
                outline: 'none',
                boxShadow: `0 0 0 3px ${booking.branch.branch_colour}`,
                transition: 'box-shadow 0.3s',
              }}
              onMouseEnter={(e) =>
                ((e.target as HTMLDivElement).style.backgroundColor =
                  darkenColor(booking.branch.branch_colour, 20))
              }
              onMouseLeave={(e) =>
                ((e.target as HTMLDivElement).style.backgroundColor =
                  booking.branch.branch_colour)
              }
              onClick={onDuplicate}
            >
              Duplicate
            </Button>
            <Button
              type="button"
              className="text-white"
              style={{
                backgroundColor: booking.branch.branch_colour,
                outline: 'none',
                boxShadow: `0 0 0 3px ${booking.branch.branch_colour}`,
                transition: 'box-shadow 0.3s',
              }}
              onMouseEnter={(e) =>
                ((e.target as HTMLDivElement).style.backgroundColor =
                  darkenColor(booking.branch.branch_colour, 20))
              }
              onMouseLeave={(e) =>
                ((e.target as HTMLDivElement).style.backgroundColor =
                  booking.branch.branch_colour)
              }
              onClick={onEdit}
            >
              Edit
            </Button>

            <Button
              type="button"
              className="text-white"
              style={{
                backgroundColor: booking.branch.branch_colour,
                outline: 'none',
                boxShadow: `0 0 0 3px ${booking.branch.branch_colour}`,
                transition: 'box-shadow 0.3s',
              }}
              onMouseEnter={(e) =>
                ((e.target as HTMLDivElement).style.backgroundColor =
                  darkenColor(booking.branch.branch_colour, 20))
              }
              onMouseLeave={(e) =>
                ((e.target as HTMLDivElement).style.backgroundColor =
                  booking.branch.branch_colour)
              }
              onClick={onCharge}
            >
              Charge
            </Button>
          </div>
        </div>
        <div className="flex flex-row space-x-3" />
      </div>

      <div
        className="mt-1 mb-10 text-sm text-gray-500"
        style={{ fontSize: '12px' }}
      >
        {formattedCreatedAt}
      </div>

      {children}

      <div className="mt-2 flex flex-row items-center justify-between gap-x-4">
        <div>
          <Button
            onClick={onDelete}
            className="bg-red-400 text-white hover:bg-red-500 focus:ring-red-400"
            type="button"
          >
            Delete Booking
          </Button>
          <Button
            onClick={booking.on_hold ? findTime : onHold}
            className="bg-red-400 text-white hover:bg-red-500 focus:ring-red-400"
            type="button"
          >
            {booking.on_hold ? 'Cancel Hold' : 'Hold'}
          </Button>
        </div>

        <div className="flex flex-row">
          {booking.status !== 6 ? (
            <Button
              type="button"
              className="text-white"
              style={{
                backgroundColor: booking.branch.branch_colour,
                outline: 'none',
                boxShadow: `0 0 0 3px ${booking.branch.branch_colour}`,
                transition: 'box-shadow 0.3s',
              }}
              onMouseEnter={(e) =>
                ((e.target as HTMLDivElement).style.backgroundColor =
                  darkenColor(booking.branch.branch_colour, 20))
              }
              onMouseLeave={(e) =>
                ((e.target as HTMLDivElement).style.backgroundColor =
                  booking.branch.branch_colour)
              }
              onClick={onCompleted}
            >
              Mark booking as completed
            </Button>
          ) : (
            <Button type="button" className="bg-gray-300 text-white" disabled>
              Booking has been completed
            </Button>
          )}
          <Button
            type="button"
            className="bg-gray-500 text-white hover:bg-gray-600 focus:ring-gray-500"
            onClick={onClose}
          >
            Close
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DetailModal;
